import React from 'react';
import {Menu, Icon} from 'antd';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import {Link} from 'react-router-dom';
import {sideMenuItems} from '../assets/constants/sideMenu.js';

const { SubMenu } = Menu;

class SideMenu extends React.Component{
  constructor(props){
    super(props);
    this.state=({
      currentOpenKeys: [],
    });
  }
  
  render(){
    return (
      <Menu
        mode="vertical"
        theme="dark"
        style={{ 
          width: 280,
          height: '100%', // both needed
          minHeight: '100vh', // both needed
          paddingTop: '80px',
          backgroundColor: '#001529',
          overflow: 'auto',
          overflowX: 'hidden' }}
        defaultOpenKeys={this.state.currentOpenKeys}
        onClick={this.props.onClick}
        selectedKeys={[this.props.currentSelection]}
      >
      {
        sideMenuItems.map((item)=>{
          if(item.list){
            return(
              <SubMenu key={item.key}
                title={
                  <span css={css`color: #ddd;`}>
                    {
                      typeof(item.icon) === "string"
                      ? <Icon type={item.icon}/>
                      : <span css={css`padding: 0 12px 0 0; color: #ddd;`}>{item.icon}</span>
                    }
                    {item.label}
                  
                  </span>
                }
              >
              {
                item.list.map((subItem, i)=>{
                  return(
                    <Menu.Item key={subItem.key}>
                      <span css={css`
                        color: #ddd;
                        a {
                          color: #ddd;
                          &:hover {
                            color: #0099e5;
                          }
                        `}>

                        {
                          typeof(subItem.icon) === "string"
                        
                          ? <Icon type={subItem.icon} />
                          : <span css={css`
                            padding: 0 12px 0 0;
                            img {
                              width: 24px;
                              height: 24px;
                            }
                          
                          `}>{subItem.icon}</span>
                        }
                        
                        {
                          subItem.value.startsWith('/')
                          ? <Link to={`${item.value}${subItem.value}`}>{subItem.label}</Link>
                          : <a href={subItem.value} target="_blank" rel="noopener noreferrer">{subItem.label}</a>
                        }
                        
                      </span>
                    </Menu.Item>
                  )
                })
              }
              </SubMenu>
            )
          }
          else{
            return(
              <Menu.Item key={item.key}>
                <span css={css`
                    color: #ddd;
                    a {
                      color: #ddd;
                      &:hover {
                        color: #0099e5;
                      }
                    `}>
                    {
                      typeof(item.icon) === "string"
                    
                      ? <Icon type={item.icon} />
                      : <span css={css`
                        padding: 0 12px 0 0;
                        img {
                          width: 24px;
                          height: 24px;
                        }
                      
                      `}>{item.icon}</span>
                    }
                  {
                    item.value.startsWith('/')
                    ? <Link to={item.value}>{item.label}</Link>
                    : <a href={item.value} target="_blank" rel="noopener noreferrer">{item.label}</a>
                  }
                  
                </span>
              </Menu.Item>
            )
          }
        })
      }
      </Menu>
    );
  }
}

export default SideMenu;